import { NextRouter } from 'next/router';

export const getIpfsHash = (router: NextRouter) => {
  const hash = router.query.ipfsHash;
  if (typeof hash === 'string') return hash;
  return '';
};
